import { styled } from '@mui/material/styles';

const TitleDiv = styled('div')(() => ({
    fontSize: '150%',
    fontWeight: 'bold',
    marginBottom: 2
}));

export default TitleDiv;
